module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "otherfm"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("ALSO BY THE AUTHOR")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Nightwatchmen")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Airships")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ray")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Tennis Handsome")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Captain Maximus")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Hey Jack!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Boomerang")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Never Die")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Bats Out of Hell")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("High Lonesome")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2881a2f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm.vue
// module id = 60
// module chunks = 0